export default __webpack_public_path__ + "static/media/GIG Logo-03.a12b962c.png";